var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-row",
        { attrs: { gutter: 10 } },
        [
          _c(
            "q-form",
            {
              ref: "postDetail",
              attrs: {
                model: _vm.model,
                rules: _vm.contentRules,
                "label-width": "20px",
                "label-position": "top",
              },
            },
            [
              _c(
                "q-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "q-panel",
                    {
                      staticClass: "panel",
                      attrs: {
                        "header-text": this.$qt("post.detail.data.title"),
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "panel-padding" },
                        [
                          _c(
                            "q-form-item",
                            {
                              attrs: {
                                label: this.$qt("post.detail.data.key"),
                                prop: "key",
                              },
                            },
                            [
                              _c("q-input", {
                                attrs: {
                                  placeholder: this.$qt(
                                    "post.detail.data.keyPlaceholder"
                                  ),
                                },
                                model: {
                                  value: _vm.model.key,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.model, "key", $$v)
                                  },
                                  expression: "model.key",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "q-form-item",
                            {
                              attrs: {
                                label: this.$qt("post.detail.data.language"),
                              },
                            },
                            [
                              _c("q-model-selector", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  plugin: "gausaka",
                                  delegate: "getLanguages",
                                  "display-field": "name",
                                  "value-field": "cultureName",
                                  placeholder: this.$qt(
                                    "post.detail.data.language"
                                  ),
                                },
                                model: {
                                  value: _vm.currentLanguage,
                                  callback: function ($$v) {
                                    _vm.currentLanguage = $$v
                                  },
                                  expression: "currentLanguage",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.inLanguage !== undefined
                            ? _c(
                                "q-form-item",
                                {
                                  attrs: {
                                    label: this.$qt("post.detail.data.version"),
                                  },
                                },
                                [
                                  _c("q-item-selector", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      items: _vm.inLanguage.versions,
                                      "display-field": "editedTime",
                                      "value-field": "versionNumber",
                                      placeholder: this.$qt(
                                        "post.detail.data.version"
                                      ),
                                    },
                                    model: {
                                      value: _vm.currentVersionNumber,
                                      callback: function ($$v) {
                                        _vm.currentVersionNumber = $$v
                                      },
                                      expression: "currentVersionNumber",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "q-form-item",
                            {
                              attrs: {
                                label: this.$qt(
                                  "post.detail.data.classification"
                                ),
                                prop: "category",
                              },
                            },
                            [
                              _c("q-model-selector", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  plugin: "edms",
                                  delegate: "getClassifications",
                                  "display-field": "subject",
                                  "value-field": "id",
                                  placeholder: this.$qt(
                                    "post.detail.data.classification"
                                  ),
                                },
                                model: {
                                  value: _vm.model.classificationId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.model, "classificationId", $$v)
                                  },
                                  expression: "model.classificationId",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("q-json", [_vm._v(_vm._s(_vm.model.categoryKey))]),
                          _vm._v(" "),
                          _c(
                            "q-form-item",
                            {
                              attrs: {
                                label: this.$qt(
                                  "post.detail.data.categoryTitle"
                                ),
                                prop: "category",
                              },
                            },
                            [
                              _c("q-model-tree", {
                                attrs: {
                                  children: "childes",
                                  label: "title",
                                  "value-field": "key",
                                  "property-key": "categoryKey",
                                  plugin: "edms",
                                  delegate: "getCategoriesForBlogList",
                                  "fetch-data": {
                                    archive: "blog",
                                  },
                                  "result-key": "categories",
                                },
                                model: {
                                  value: _vm.model.categoryKey,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.model, "categoryKey", $$v)
                                  },
                                  expression: "model.categoryKey",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "q-form-item",
                            {
                              attrs: {
                                label: this.$qt(
                                  "post.detail.data.bgColorTitle"
                                ),
                                prop: "bgColor",
                              },
                            },
                            [
                              _c("q-color-picker", {
                                attrs: {
                                  placeholder: this.$qt(
                                    "post.detail.data.bgColorPlaceholder"
                                  ),
                                },
                                model: {
                                  value: _vm.model.bgColor,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.model, "bgColor", $$v)
                                  },
                                  expression: "model.bgColor",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "q-form-item",
                            {
                              attrs: {
                                label: this.$qt("post.detail.data.colorTitle"),
                                prop: "color",
                              },
                            },
                            [
                              _c("q-color-picker", {
                                attrs: {
                                  placeholder: this.$qt(
                                    "post.detail.data.colorPlaceholder"
                                  ),
                                },
                                model: {
                                  value: _vm.model.color,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.model, "color", $$v)
                                  },
                                  expression: "model.color",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("q-form-item", {
                            attrs: {
                              label: this.$qt("post.detail.data.tagsTitle"),
                              prop: "tags",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "q-form-item",
                            {
                              attrs: {
                                label: this.$qt(
                                  "post.detail.data.thumbnailTitle"
                                ),
                                prop: "thumbnail",
                              },
                            },
                            [
                              _c("q-upload", {
                                attrs: { type: "image" },
                                model: {
                                  value: _vm.model.thumbnail,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.model, "thumbnail", $$v)
                                  },
                                  expression: "model.thumbnail",
                                },
                              }),
                              _vm._v(" "),
                              _vm.model.thumbnail
                                ? _c("img", {
                                    attrs: {
                                      src: _vm.model.thumbnail,
                                      width: "200px",
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "q-form-item",
                            {
                              attrs: {
                                label: this.$qt("post.detail.data.imageTitle"),
                                prop: "image",
                              },
                            },
                            [
                              _c("q-upload", {
                                attrs: { type: "image" },
                                model: {
                                  value: _vm.model.image,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.model, "image", $$v)
                                  },
                                  expression: "model.image",
                                },
                              }),
                              _vm._v(" "),
                              _vm.model.image
                                ? _c("img", {
                                    attrs: {
                                      src: _vm.model.image,
                                      width: "200px",
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.model.seo !== undefined
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "q-form-item",
                                    {
                                      attrs: {
                                        label: this.$qt(
                                          "post.detail.data.seoTitle"
                                        ),
                                        prop: "seoTitle",
                                      },
                                    },
                                    [
                                      _c("q-input", {
                                        attrs: {
                                          placeholder: this.$qt(
                                            "post.detail.data.seoTitlePlaceholder"
                                          ),
                                        },
                                        model: {
                                          value: _vm.model.seo.title,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.model.seo,
                                              "title",
                                              $$v
                                            )
                                          },
                                          expression: "model.seo.title",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "q-form-item",
                                    {
                                      attrs: {
                                        label: this.$qt(
                                          "post.detail.data.seoDescriptionTitle"
                                        ),
                                        prop: "seoDescription",
                                      },
                                    },
                                    [
                                      _c("q-input", {
                                        attrs: {
                                          type: "textarea",
                                          rows: 4,
                                          placeholder: this.$qt(
                                            "post.detail.data.seoDescriptionPlaceholder"
                                          ),
                                        },
                                        model: {
                                          value: _vm.model.seo.description,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.model.seo,
                                              "description",
                                              $$v
                                            )
                                          },
                                          expression: "model.seo.description",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "q-form-item",
                                    {
                                      attrs: {
                                        label: this.$qt(
                                          "post.detail.data.seoKeywordsTitle"
                                        ),
                                        prop: "seoKeywords",
                                      },
                                    },
                                    [
                                      _c("q-input", {
                                        attrs: {
                                          type: "textarea",
                                          rows: 6,
                                          placeholder: this.$qt(
                                            "post.detail.data.seoKeywordsPlaceholder"
                                          ),
                                        },
                                        model: {
                                          value: _vm.model.seo.keywords,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.model.seo,
                                              "keywords",
                                              $$v
                                            )
                                          },
                                          expression: "model.seo.keywords",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("q-col", { attrs: { span: 18 } }, [
                _vm.currentVersion !== undefined
                  ? _c(
                      "div",
                      [
                        _c(
                          "q-panel",
                          {
                            staticClass: "panel",
                            attrs: {
                              "header-text": this.$qt(
                                "post.detail.generalTitle"
                              ),
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "panel-padding" },
                              [
                                _c(
                                  "q-form-item",
                                  { attrs: { prop: "title" } },
                                  [
                                    _c("q-input", {
                                      attrs: {
                                        disabled: false,
                                        placeholder: this.$qt(
                                          "post.detail.titlePlaceholder"
                                        ),
                                      },
                                      model: {
                                        value: _vm.currentVersion.subject,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.currentVersion,
                                            "subject",
                                            $$v
                                          )
                                        },
                                        expression: "currentVersion.subject",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "q-form-item",
                                  { attrs: { prop: "textType" } },
                                  [
                                    _c(
                                      "q-select",
                                      {
                                        model: {
                                          value: _vm.currentVersion.textType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.currentVersion,
                                              "textType",
                                              $$v
                                            )
                                          },
                                          expression: "currentVersion.textType",
                                        },
                                      },
                                      [
                                        _c("q-option", {
                                          attrs: {
                                            label: this.$qt(
                                              "post.detail.textType.marked"
                                            ),
                                            value: "Marked",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("q-option", {
                                          attrs: {
                                            label: this.$qt(
                                              "post.detail.textType.html"
                                            ),
                                            value: "Html",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("q-option", {
                                          attrs: {
                                            label: this.$qt(
                                              "post.detail.textType.text"
                                            ),
                                            value: "Text",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "q-form-item",
                                  { attrs: { prop: "text" } },
                                  [
                                    _vm.currentVersion.textType === "Marked"
                                      ? [
                                          _c("q-input", {
                                            attrs: {
                                              dir: "ltr",
                                              type: "textarea",
                                              rows: 25,
                                              placeholder: this.$qt(
                                                "post.detail.markedContentPlaceholder"
                                              ),
                                            },
                                            model: {
                                              value: _vm.currentVersion.text,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.currentVersion,
                                                  "text",
                                                  $$v
                                                )
                                              },
                                              expression: "currentVersion.text",
                                            },
                                          }),
                                        ]
                                      : _vm.currentVersion.textType === "Html"
                                      ? [
                                          _c("q-input", {
                                            attrs: {
                                              dir: "ltr",
                                              type: "textarea",
                                              rows: 25,
                                              placeholder: this.$qt(
                                                "post.detail.htmlContentPlaceholder"
                                              ),
                                            },
                                            model: {
                                              value: _vm.currentVersion.text,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.currentVersion,
                                                  "text",
                                                  $$v
                                                )
                                              },
                                              expression: "currentVersion.text",
                                            },
                                          }),
                                        ]
                                      : [
                                          _c("q-input", {
                                            attrs: {
                                              type: "textarea",
                                              rows: 25,
                                              placeholder: this.$qt(
                                                "post.detail.textContentPlaceholder"
                                              ),
                                            },
                                            model: {
                                              value: _vm.currentVersion.text,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.currentVersion,
                                                  "text",
                                                  $$v
                                                )
                                              },
                                              expression: "currentVersion.text",
                                            },
                                          }),
                                        ],
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "q-form-item",
                                  { attrs: { prop: "summary" } },
                                  [
                                    _c("q-input", {
                                      attrs: {
                                        type: "textarea",
                                        rows: 4,
                                        disabled: false,
                                        placeholder: this.$qt(
                                          "post.detail.summaryPlaceholder"
                                        ),
                                      },
                                      model: {
                                        value: _vm.currentVersion.summary,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.currentVersion,
                                            "summary",
                                            $$v
                                          )
                                        },
                                        expression: "currentVersion.summary",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "q-panel",
                          {
                            staticClass: "panel",
                            attrs: {
                              "header-text": this.$qt(
                                "post.detail.commentsTitle"
                              ),
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "panel-padding" },
                              [
                                _c(
                                  "q-form-item",
                                  { attrs: { prop: "comments" } },
                                  [
                                    _c("q-composite-list", {
                                      attrs: { "structure-key": "comment" },
                                      model: {
                                        value: _vm.model.comments,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.model, "comments", $$v)
                                        },
                                        expression: "model.comments",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _c("div", [
                      _c("span", [
                        _vm._v("Please select language and version"),
                      ]),
                    ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }